import { Injectable } from '@angular/core';

import {
  PushPermisoDenegadoError,
  PushPlataformaCliente,
  PushSuscribirDeps,
} from '../../shared/interfaces/push.interface';
import { suscribirConClave } from '../utils/push-clave';

/**
 * Android (Chrome, Edge, Samsung Internet, Firefox) y navegadores de escritorio.
 * Push funciona en una pestaña común, sin instalar la app.
 */
@Injectable({ providedIn: 'root' })
export class PushAndroidService implements PushPlataformaCliente {
  readonly plataforma = 'android' as const;

  bloqueo(): 'no-soportado' | null {
    const soportado =
      'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
    return soportado ? null : 'no-soportado';
  }

  async suscribir(deps: PushSuscribirDeps): Promise<PushSubscription> {
    const [permiso, registro, clavePublica] = await Promise.all([
      Notification.requestPermission(),
      deps.registro(),
      deps.clavePublica(),
    ]);
    if (permiso !== 'granted') {
      throw new PushPermisoDenegadoError();
    }

    return suscribirConClave(registro, clavePublica);
  }
}
